/**---------------GB28181服务器信息配置-------------------**/
const serverip="192.168.1.20:18080"

const host = 'http://' + serverip;
/**------------------------------------------------------**/


/**---------------ZLMediaKit流媒体服务器配置---------------**/
const ZLServerIp="127.0.0.1:10080";
const ZLSecret="035c73f7-bb6b-4889-a715-d9eb2d1925cc";

const ZLHost='http://' + ZLServerIp+"";
const baseMediaUrl='ws://' + ZLServerIp + '/';
/**------------------------------------------------------**/

//生成GB28181平台接口url
function genGb28181Url(method){
	return method;
	// return host+method;
}

//生成ZLMediaKit平台接口url
function genApiUrl(method){
	// return ZLHost+method+"?secret="+ZLSecret;
	return "/media" + method+"?secret="+ZLSecret;
}



export default{
	genApiUrl,
	genGb28181Url,
	baseMediaUrl,
	ZLServerIp
}
